module.exports = __webpack_public_path__ + "static/media/icons8-lock.3cecfdb5.svg";